import { checkTranslated } from 'app/utils/helpers';
import React from 'react';
import { Marker, useMapEvents } from 'react-leaflet';
type Prop = {
  currentCountries: any;
  getIcon: any;
  fontSizeEquation: any;
  refetchHahtages: any;
};
const MapContent: React.FC<Prop> = ({
  currentCountries,
  getIcon,
  fontSizeEquation,
  refetchHahtages,
}) => {
  const map = useMapEvents({
    zoomend() {
      refetchHahtages(map.getCenter(), map.getBounds(), map);
    },
    dragend() {
      refetchHahtages(map.getCenter(), map.getBounds(), map);
    },
  });
  return (
    <>
      {currentCountries &&
        currentCountries?.map((item: any, index: number) => (
          <Marker
            position={[item.lat, item.long]}
            icon={getIcon({
              name: `${
                typeof item?.name === 'string'
                  ? item?.name
                  : checkTranslated(item?.name?.original, item?.name?.arabic)
              }`,
              id: item?.id,
              image_url: item?.image_url,
              fontSize: fontSizeEquation(+item?.percentage),
            })}
            key={`${item?.country_name}${index}${
              item?.name === 'string' ? item?.name : item?.name
            }`}
          />
        ))}
    </>
  );
};

export default MapContent;
